module.exports = __webpack_public_path__ + "img/pic2-2.1776455c.png";